import type { WithPagination } from "../../../../types/types";
import {
  getActivityListEndpoint,
  getActivityListParams,
} from "../../../../util/activityEndpoints";
import { makeUrlWithParams } from "../../../../util/util";
import type { ActivityHistoryItem } from "./types";
import type { ActivityTargetType } from "../../../../util/activityEndpoints";

export const ACTIVITIES_PAGE_SIZE = 100;

function num(v: unknown, fallback: number): number {
  const n = Number(v);
  return Number.isFinite(n) ? n : fallback;
}

export function activitiesHasMoreAfterPage(
  page: WithPagination<{ data: ActivityHistoryItem[] }> | undefined
): boolean {
  if (!page?.pagination) return false;
  const total = num(page.pagination.total, 0);
  const offset = num(page.pagination.offset, 0);
  const count = page.data?.length ?? 0;
  if (offset > 0 && count === 0) return false;
  return offset + count < total;
}

interface ActivitiesKeyBuilderArgs {
  tenantId?: string;
  targetId?: string;
  targetType?: ActivityTargetType;
  enabled: boolean;
  includeDetails: boolean;
  versionNumber?: number | null;
  pageSize?: number;
}

export function fetchActivities({
  tenantId,
  targetId,
  targetType,
  enabled,
  includeDetails,
  versionNumber,
  pageSize = ACTIVITIES_PAGE_SIZE,
}: ActivitiesKeyBuilderArgs) {
  return (
    index: number,
    previousPageData: WithPagination<{ data: ActivityHistoryItem[] }> | null
  ) => {
    if (!enabled || !tenantId || !targetId || !targetType) return null;
    if (
      includeDetails &&
      (versionNumber === null || versionNumber === undefined)
    ) {
      return null;
    }

    if (index > 0 && !previousPageData) return null;
    if (previousPageData && !activitiesHasMoreAfterPage(previousPageData)) {
      return null;
    }

    const endpoint = getActivityListEndpoint(targetType, tenantId, targetId);
    const query = getActivityListParams(targetType, targetId, {
      offset: index * pageSize,
      limit: pageSize,
    });

    return makeUrlWithParams(endpoint, {
      ...query,
      include_details: includeDetails ? "true" : "false",
      version_number: includeDetails ? versionNumber : undefined,
    });
  };
}
